import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Document, Page, View, StyleSheet, Text, Image, Font, PDFViewer } from "@react-pdf/renderer";
import imgKkp from "../../../assets/images/logo_kkp.jpg";
import srcArial from "../../../assets/custom/font/arial/arial.ttf";
import srcArialBold from "../../../assets/custom/font/arial/ARIBL0.ttf";
import NonlalinService from "../../../services/nonlalin/NonlalinService";
import MasterService from "../../../services/master/MasterService";
import UserService from "../../../services/user/UserService";
import { formatDateStringLocalDateINA, getNamaUPTBaru } from "../../../utilities/Utils";
import Kemasan from "../../../utilities/Kemasan";

Font.register({ family: "Arial", src: srcArial });
Font.register({ family: "Arial-Bold", src: srcArialBold });

const styles = StyleSheet.create({
  page: {
    paddingTop: 20,
    paddingBottom: 40,
    paddingHorizontal: 40,
    fontFamily: "Arial",
  },
  headerLogo: {
    width: 80,
    height: 80,
  },
  centerText: {
    textAlign: "center",
  },
  title: {
    fontFamily: "Arial-Bold",
    fontSize: 14,
    textAlign: "center",
    marginTop: 4,
  },
  subtitle: {
    fontSize: 12,
    textAlign: "center",
  },
  sectionTitle: {
    fontFamily: "Arial-Bold",
    fontSize: 12,
    marginTop: 2,
    marginBottom: 2,
  },
  table: {
    display: "table",
    width: "100%",
    borderStyle: "solid",
    borderColor: "#000",
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  table1: {
    display: "table",
    width: "100%",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#000",
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    flexDirection: "row",
  },
  tableColKey: {
    width: "35%",
    paddingLeft: 8,
    paddingTop: 3,
  },
  tableColSeparator: {
    width: "5%",
    paddingTop: 3
  },
  tableColValue: {
    width: "60%",
    paddingTop: 3,
  },
  text: {
    fontSize: 10,
  },

  tableSampleHeader: {
    flexDirection: "row",
    backgroundColor: "#f2f2f2",
  },
  tableCell: {
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#000",
    padding: 3,
    fontSize: 9,
    textAlign: "center",
  },
    
  tableContainer: {
    marginTop: 15,
    marginBottom: 10,
  },
  tableHeaderTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 6,
  },
  thText: {
    fontSize: 9,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  tdText: {
    fontSize: 10,
    textAlign: 'center',
    paddingVertical: 4,
  },
  noteText: {
    fontSize: 8,
    fontStyle: 'italic',
    marginTop: 4,
  },
  colNo: { width: '5%', borderRightWidth: 1, borderColor: '#000', justifyContent: 'center', padding: 4 },
  colJenis: { width: '15%', borderRightWidth: 1, borderColor: '#000', justifyContent: 'center', padding: 4 },
  colAsal: { width: '12%', borderRightWidth: 1, borderColor: '#000', justifyContent: 'center', padding: 4 },
  colSR: { width: '8%', borderRightWidth: 1, borderColor: '#000', justifyContent: 'center', padding: 4 },
  colFCR: { width: '8%', borderRightWidth: 1, borderColor: '#000', justifyContent: 'center', padding: 4 },
  colProduksi: { width: '16%', borderRightWidth: 1, borderColor: '#000', justifyContent: 'center', padding: 4 },
  colSiklus: { width: '14%', borderRightWidth: 1, borderColor: '#000', justifyContent: 'center', padding: 4 },
  colUkuran: { width: '12%', borderRightWidth: 1, borderColor: '#000', justifyContent: 'center', padding: 4 },
  colPembeli: { width: '10%', justifyContent: 'center', padding: 4 }, 
});

const Header = () => <View
  fixed
  style={{
    display: "table",
    width: "100%",
    border: "1 solid #000",
    marginBottom: 10,
  }}
>

  <View style={{ flexDirection: "row", alignItems: "center" }}>
    <View
      style={{
        width: "25%",
        borderRight: "1 solid #000",
        alignItems: "center",
        justifyContent: "center",
        padding: 4,
      }}
    >
      <Image src={imgKkp} style={{ width: 80, height: 70 }} />
    </View>

    <View
      style={{
        width: "75%",
        alignItems: "center",
        justifyContent: "center",
        padding: 6,
      }}
    >
      <Text
        style={{
          fontFamily: "Arial-Bold",
          fontSize: 12,
          textAlign: "center",
        }}
      >
        KEMENTERIAN KELAUTAN DAN PERIKANAN
      </Text>
      <Text
        style={{
          fontFamily: "Arial-Bold",
          fontSize: 12,
          textAlign: "center",
        }}
      >
        BADAN PENGENDALIAN DAN PENGAWASAN MUTU HASIL KELAUTAN DAN PERIKANAN
      </Text>
    </View>
  </View>

  <View
    style={{
      borderTop: "1 solid #000",
      paddingVertical: 4,
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <Text
      style={{
        fontFamily: "Arial-Bold",
        fontSize: 11,
        textAlign: "center",
      }}
    >
      FORMULIR PERMOHONAN 
    </Text>
    <Text
      style={{
        fontFamily: "Arial-Bold",
        fontSize: 11,
        textAlign: "center",
      }}
    >
      SERTIFIKASI CARA PEMBENIHAN IKAN YANG BAIK (CPIB)
    </Text>
  </View>
</View>;

const FormCPIB = () => {

    return (
      <Document>
        <Page size="A4" style={styles.page}>
          <Header />

          <Text style={styles.sectionTitle}>
            DATA PENGAJUAN SERTIFIKASI CPIB
          </Text>
          <View style={styles.table}>
            {[
              ["Nomor Pengajuan", ""],
              ["Tanggal Pengajuan", ""],
              ["UPT", ""],
              ["Nama Pemohon", ""],
            ].map(([label, value], i) => (
              <View key={i} style={styles.tableRow}>
                <View style={styles.tableColKey}>
                  <Text style={styles.text}>{label}</Text>
                </View>
                <View style={styles.tableColSeparator}>
                  <Text style={styles.text}>:</Text>
                </View>
                <View style={styles.tableColValue}>
                  <Text style={styles.text}>{value}</Text>
                </View>
              </View>
            ))}
          </View>

              {/*  A - DATA PERMOHONAN */}
                 <Text style={[styles.sectionTitle, { marginTop: 10 }]}>A. DATA PERMOHONAN</Text>
                    <View style={styles.table}>
                      {[
                       ["Nama Unit Pembenihan Ikan", ""], 
                        ["Nama Pimpinan", ""],
                        ["HP/Telp dan Fax", ""],
                        ["Tahun Pendirian", ""],
                        ["Tahun Mulai Beroperasi", ""],
                        ["Lokasi Usaha", ""], 
                        ["Skala Usaha", ""],

                        // ["Luas bersih lahan budidaya", ""],
                        // ["Status kepemilikan", ""],
                        // ["Nomor Izin Berusaha", ""], 
                        // ["Tahun mulai berbudidaya ikan", ""],
                      ].map(([label, value], i) => {
                        
                    if (label === "Lokasi Usaha") {
                      return (
                        <React.Fragment key={i}>
                          <View style={styles.tableRow}>
                            <View style={styles.tableColKey}>
                              <Text style={styles.text}>{i + 1}. {label}</Text>
                            </View>
                            <View style={styles.tableColSeparator}>
                              <Text style={styles.text}></Text> 
                            </View>
                            <View style={styles.tableColValue}>
                              <Text style={styles.text}></Text>
                            </View>
                          </View>
                          {[
                            ["Desa", "Semangkulon"],
                            ["Kecamatan", "Semarang"],
                            ["Kab/Kota", "Semarang"],
                            ["Propinsi", "JATENG"],
                            ["GPS", "-6.9667"],
                          ].map(([subLabel, subValue], subIndex) => (
                            <View key={subIndex} style={styles.tableRow}>
                              <View style={[styles.tableColKey, { paddingLeft: 18 }]}>
                                <Text style={styles.text}>-  {subLabel}</Text>
                              </View>
                              <View style={styles.tableColSeparator}>
                                <Text style={styles.text}>:</Text>
                              </View>
                              <View style={styles.tableColValue}>
                                <Text style={styles.text}>{subValue}</Text>
                              </View>
                            </View>
                          ))}
                        </React.Fragment>
                      );
                    }
                        return (
                          <View key={i} style={styles.tableRow}>
                            <View style={styles.tableColKey}>
                              <Text style={styles.text}>{i + 1}. {label}</Text>
                            </View>
                            <View style={styles.tableColSeparator}>
                              <Text style={styles.text}>:</Text>
                            </View>
                            <View style={styles.tableColValue}>
                              <Text style={styles.text}>{value}</Text>
                            </View>
                          </View>
                        );
                      })}
                    </View>

                  <View style={styles.tableContainer}>
                    <Text style={styles.sectionTitle}>B. DATA PRODUK PEMBENIHAN</Text>
                    <View style={styles.table}>
                      {[
                        ["Deskripsi Produk", ""], 
                        ["Asal Induk/Telur/Larva", ""],
                        ["Alamat Asal Induk/telur/larva", ""],
                        ["Kapasitas produksi (ekor/ tahun)", ""],
                        ["Produksi riil rata-rata per tahun (ekor/tahun)", ""],
                        ["Jumlah siklus per tahun", ""],
                        ["Jumlah benih per siklus (ekor)", ""],
                        ["Tingkat Risiko", ""],
                      ].map(([label, value], i) => {
                        
                    if (label === "Deskripsi Produk") {
                      return (
                        <React.Fragment key={i}>
                          <View style={styles.tableRow}>
                            <View style={styles.tableColKey}>
                              <Text style={styles.text}>{i+1}. {label}</Text>
                            </View>
                            <View style={styles.tableColSeparator}>
                              <Text style={styles.text}></Text> 
                            </View>
                            <View style={styles.tableColValue}>
                              <Text style={styles.text}></Text>
                            </View>
                          </View>
                          {[
                            ["Jenis Komoditi", "Ikan Nila"],
                            ["Umur", "4 Hari"],
                            ["Ukuran", "4 cm"],
                          ].map(([subLabel, subValue], subIndex) => (
                            <View key={subIndex} style={styles.tableRow}>
                              <View style={[styles.tableColKey, { paddingLeft: 18 }]}>
                                <Text style={styles.text}>-  {subLabel}</Text>
                              </View>
                              <View style={styles.tableColSeparator}>
                                <Text style={styles.text}>:</Text>
                              </View>
                              <View style={styles.tableColValue}>
                                <Text style={styles.text}>{subValue}</Text>
                              </View>
                            </View>
                          ))}
                        </React.Fragment>
                      );
                    }
                        return (
                          <View key={i} style={styles.tableRow}>
                            <View style={styles.tableColKey}>
                              <Text style={styles.text}>{i+1}. {label}</Text>
                            </View>
                            <View style={styles.tableColSeparator}>
                              <Text style={styles.text}>:</Text>
                            </View>
                            <View style={styles.tableColValue}>
                              <Text style={styles.text}>{value}</Text>
                            </View>
                          </View>
                        );
                      })}
                    </View>
                  </View>

              {/*  C - MANAJER PENGENDALI MUTU */}
                 <Text style={[styles.sectionTitle, { marginTop: 10 }]}>C. MANAJER PENGENDALI MUTU (MPM)</Text>
                    <View style={styles.table}>
                      {[
                       ["Nomor Sertifikat MPM ", ""], 
                        ["Tahun Kelulusan", ""],
                        ["HP/Telp dan Fax", ""],
                        
                      ].map(([label, value], i) => {
                    
                        return (
                          <View key={i} style={styles.tableRow}>
                            <View style={styles.tableColKey}>
                              <Text style={styles.text}>{i + 1}. {label}</Text>
                            </View>
                            <View style={styles.tableColSeparator}>
                              <Text style={styles.text}>:</Text>
                            </View>
                            <View style={styles.tableColValue}>
                              <Text style={styles.text}>{value}</Text>
                            </View>
                          </View>
                        );
                      })}
                    </View>

        </Page>
      </Document>
    );
}
// const FormPermohananView = ({ rowData }) => (
//   <PDFViewer width="100%" height="800">
//     <FormCPIB rowData={rowData} />
//   </PDFViewer>
// );

// export default FormPermohananView;

export default FormCPIB;